export default __webpack_public_path__ + "static/media/recentlyimpaired.df6de71f.png";